export default "__VITE_ASSET__ZHU9Sgzr__"